import React from 'react';
import { AutoPayTermsAndConditions as PCLTermsAndConditions } from '@ace-clublabs/payments-component-library';
import Header from '../components/Header';

const AutoPayTermsAndConditions: React.FC = () => {
  return (
    <div className="terms-and-conditions-container inner-container" tabIndex={0}>
      <Header />
      <PCLTermsAndConditions />
    </div>
  );
};

export default AutoPayTermsAndConditions;
